<template>
	<div>
		<v-toolbar color="primary">
			<v-toolbar-title class="ml-0 pl-3 white--text" style>
				<strong><span
						style="font-size:1.2rem;">Visa Conversion from {{
						extendConvertVisaDetail.visa_type
					}} to {{ selected_visa_type.type }}</span></strong>
			</v-toolbar-title>
		</v-toolbar>
		<v-card class="ma-2 px-3 py-0" white>
			<v-card-text>
				<v-layout wrap>
					<v-flex xs12>
						<v-form lazy-validation ref="formRef" row wrap>
							<v-layout row>

								<confirmation-header-text :text="headerText"
								                          class="ml-0 mb-3"
								                          icon="mdi-card-bulleted"/>

								<v-flex xs12>
									<v-alert type="info"
									         v-if="viewData.fill_dependent_data">
										Please fill the dependent person data
									</v-alert>
								</v-flex>
								<!--                <v-flex v-if="showSelectVisaType" xs12>-->
								<!--                  <v-select-->
								<!--                      :items="dependent_visa_options"-->
								<!--                      label="Visa types for dependent"-->
								<!--                      :rules="[rules.required]"-->
								<!--                      item-text="type"-->
								<!--                      item-value="id"-->
								<!--                      min="0"-->
								<!--                      outlined-->
								<!--                      @change="getConditionForDependent"-->
								<!--                      v-model="extendConvertData.extend_visa_type"-->
								<!--                  />-->
								<!--                </v-flex>-->

								<v-flex xs12>
									<v-alert outlined
									         type="info" v-if="borderCaseReachedDay > 0">
										{{
											borderCaseReachedDay > 0 ? 'This is border case. You will get ' + borderCaseReachedDay + ' days visa free and cost of ' + (parseInt(extendConvertData.days_staying) - borderCaseReachedDay) + ' days' : ''
										}}
										<br>
									</v-alert>
                  <v-alert
											outlined
											type="info"
											v-if="cost && !extendConvertData.hasOwnProperty('is_special_overstay_regulation')">
										Your visa cost will be <strong>USD($){{ cost }}</strong> with
										<strong>{{ plan }}</strong>
									</v-alert>
								</v-flex>
								<v-flex xs12>
									<v-alert
											type="error"
											v-if="viewData.invalid_date && extendConvertData.condition">
										Sorry, you cannot apply for {{ extendConvertData.days_staying }} days.
										Please contact immigration office for further information
									</v-alert>
								</v-flex>
								<v-flex xs12>
									<v-alert
											type="error"
											v-if="checkIfApplicantsApplicableForAgeCondition == 0">
										Sorry, you cannot apply for the selected condition. Because your age is {{ getAge() }} and doesn't
										fall under the age group.
									</v-alert>
								</v-flex>
								<v-flex xs12>
									<v-alert
											type="error"
											v-if="!extendConvertData.condition && extendConvertData.days_staying">
										Please select available conditions first.
									</v-alert>
								</v-flex>
								<v-flex xs12>
									<v-alert
											type="error"
											v-if="!conditions.length">
										No visa categories found for your document type {{ extendConvertVisaDetail.document_type }}. Please
										consult with Department of Immigration
									</v-alert>
								</v-flex>

								<late-info-message :overstay="1" v-if="extendConvertData.hasOwnProperty('is_special_overstay_regulation')"/>
								<late-info-message :convert="true" v-else/>

								<v-flex xs12 v-if="!fetchedConditionForBorderCase">
									<v-select
											:items="conditions"
											:label="'Available options for '+(selected_visa_type?selected_visa_type.type :'')+' *'"
											:rules="[rules.required]"
											item-text="name"
											item-value="id"
											outlined
											v-if="visa_type_slug !== 'dependent-visa'"
											v-model="extendConvertData.condition"
									/>
								</v-flex>
								<v-flex xs12 v-if="fetchedConditionForBorderCase">
									<v-select
											:items="conditions"
											:label="'Available options for '+(selected_visa_type?selected_visa_type.type :'')+' *'"
											:rules="[rules.required]"
											item-text="name"
											item-value="id"
											outlined
											v-if="visa_type_slug !== 'dependent-visa'"
											v-model="extendConvertData.condition"
									/>
								</v-flex>
								<v-flex xs12 v-if="fetchedConditionForBorderCase">
									<v-select
											:items="border_case_extend_condition"
											:label="'Available options for '+(selected_visa_type?selected_visa_type.type :'')+' *'"
											:rules="[rules.required]"
											item-text="name"
											item-value="id"
											min="0"
											outlined
											v-if="visa_type_slug !== 'dependent-visa'"
											v-model="extendConvertData.border_condition"
									/>
								</v-flex>
								<v-flex class="pl-3 pr-3" sm4 xs12>
									<date-picker-new
											:watch-value="true"
											label="Visa starting date * "
											v-model="extendConvertData.start_date"
									/>
								</v-flex>

								<v-flex class="pl-2" sm4 xs12>
									<v-text-field
											:rules="[rules.required,rules.maximumDays]"
											label="Number of Days Staying *"
											min="0"
											onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
											outlined
											type="number"
											v-model="extendConvertData.days_staying"
									/>
								</v-flex>

								<v-flex class="pl-2 " sm4 xs12>
									<v-text-field
											:value="expiry_date"
											disabled
											label="Expiry date *"
											min="0"
											outlined
									/>
								</v-flex>

								<v-flex class="pl-2 " sm7
								        v-if="previous_visa_type_slug === 'consular-gratis-visa'"
								        xs12>
									<v-checkbox
											label="I want to apply for gratis free visa (Applicable for consulars only)"
											outlined
											v-model="extendConvertData.apply_with_gratis"
									/>
								</v-flex>

								<v-flex v-if="viewData.show_sre||viewData.show_mre" xs12>
									<v-radio-group row v-model="extendConvertData.visaPlan">
										<v-radio :value="1" label="Apply with Plain"
										         v-if="viewData.show_sre"/>
										<v-radio :value="2" label="Apply with SRE (Single Re-entry)"
										         v-if="viewData.show_sre && visa_type_slug !== 'tourist-visa'"/>
										<v-radio :value="3" label="Apply with MRE (Multiple Re-entry)"
										         v-if="viewData.show_mre"/>
									</v-radio-group>
								</v-flex>

								<v-flex v-if="message" xs12>
									<v-alert
											outlined
											type="info">{{ message }}
									</v-alert>
								</v-flex>

								<v-flex v-if="extension_message" xs12>
									<v-alert
											outlined
											type="info">{{ extension_message }}
									</v-alert>
								</v-flex>
								<!---->
								<component v-bind:is="selected_visa_type.slug" v-if="selected_visa_type"    :extra-data="selected_visa_type.slug === 'nrn-visa' ? extendConvertData.condition : null"
                           :for-processing="true"/>

								<documents :documents="documents" headerText="Documents to submit" class="mx-3"/>

								<attach-documents :documents="documents" headerText="Attach Documents" class="mx-3"/>

								<v-flex xs12>
									<v-checkbox
											v-model="agree_terms_and_conditions"
											label="I hereby declare that the submitted data and documents herein is true and accurate, and if found false, I am aware that I may be liable for it and bear legal consequences."
									></v-checkbox>
								</v-flex>

							</v-layout>
						</v-form>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn
						@click="backBtnClicked()"
						color="error"
						large
						v-if="!invalid_date">
					{{ $vuetify.lang.t('$vuetify.back') }}
				</v-btn>
				<v-btn
						:disabled="!conditions.length || checkIfApplicantsApplicableForAgeCondition == 0 || !agree_terms_and_conditions"
						@click="proceedConfirm"
						color="primary"
						large
						v-if="!invalid_date">
					{{ $vuetify.lang.t('$vuetify.proceed') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
import ToolBar from "../../components/ToolBar";
import {mapActions, mapGetters} from 'vuex';

import TouristVisa from "../../components/visa/form/TouristVisa";
import NonTouristVisa from "../../components/visa/form/NonTouristVisa";
import StudyVisa from "../../components/visa/form/StudyVisa";
import MarriageVisa from "../../components/visa/form/MarriageVisa";
import NRNVisa from "../../components/visa/form/NRNVisa";
import PressVisa from "../../components/visa/form/PressVisa";
import RelationVisa from "../../components/visa/form/RelationVisa";
import ResidentialVisa from "../../components/visa/form/ResidentialVisa";
import WorkingVisa from "../../components/visa/form/WorkingVisa";
import FileInput from "../../components/FileInput";
import {validationMixin} from "../../mixins/validationMixin";
import LateInfoMessage from "../../components/LateInfoMessage";
import DependentVisa from "../../components/visa/form/DependentVisa";
import BusinessVisa from "../../components/visa/form/BusinessVisa";
import ConsularGratisVisa from "@/components/visa/form/ConsularGratisVisa.vue";
import ConfirmationHeaderText from "../../components/ConfirmationHeaderText";
import ReciprocityVisa from "../../components/visa/form/ReciprocityVisa";
import DatePickerNew from "../../components/DatePickerNew";
import Documents from "../../components/Documents";

import moment from "moment"
import {VISA_PLANS} from "../../constant/appConstant";
import AttachDocuments from "../../components/AttachDocuments";

export default {
	name: "ConvertForm",
	components: {
		AttachDocuments,
		DatePickerNew,
		ToolBar,
		TouristVisa,
		NonTouristVisa,
		StudyVisa,
		MarriageVisa,
		'nrn-visa': NRNVisa,
		RelationVisa,
		ResidentialVisa,
		WorkingVisa,
		FileInput,
		LateInfoMessage,
		DependentVisa,
		BusinessVisa,
		PressVisa,
        ConsularGratisVisa,
		ConfirmationHeaderText,
		ReciprocityVisa,
		Documents,
	},
	data() {
		return {
			invalid_date: false,
			selectedPlan: null,
			start_date: new Date().toISOString().substr(0, 10),
			visa_plans: VISA_PLANS,
			extraPass: false,
			fetchedConditionForBorderCase: false,
			borderCaseReachedDay: 0,
			agree_terms_and_conditions: false,
		}
	}
	,
	mixins: [validationMixin],
	methods:
			{
				...mapActions({
					fetchBorderCaseConditionForConvert: 'VisaType/fetchBorderCaseConditionForConvert',
				}),
				getConditionForDependent() {
					this.$store.dispatch('VisaType/fetchConditionForDependentExtend')
					// this.$store.dispatch('VisaType/fetchConditionForDependentExtend', this.extendConvertData.extend_visa_type)
				},
				backBtnClicked() {
					this.$router.go(-1);
				},
				overStayedOrLate() {
					if (this.extendConvertVisaDetail) {
						return this.extendConvertVisaDetail.late_days > 0 || this.extendConvertVisaDetail.overstayed > 0;
					}
					return false;
				},
				proceedConfirm() {
					if (this.$refs.formRef.validate()) {
						if (this.extendConvertData.start_date > moment(this.extendConvertVisaDetail.expiry_date).add(1, 'days').format('Y-MM-DD')) {
							if (!this.overStayedOrLate() && this.visa_type_slug !== 'working-visa') {
								this.$store.commit('Notification/showError', 'You cannot apply. Your start date is greater than his/her current visa expiry date')
								return
							}
						}
						if (this.extendConvertData.days_staying < this.extendConvertVisaDetail.late_days) {
							this.$store.commit('Notification/showError', 'You need to apply for minimum ' + this.extendConvertVisaDetail.late_days + " days")
							return
						}
						let cost = this.cost;
						const visa_type = this.$store.state.VisaSingle.convert_visa_options.find(i => i.id === this.extendConvertData.visa_type);
						// cost += (this.$store.state.VisaSingle.extendConvertVisaDetail.late_days * visa_type.late_fee_per_day);
						this.extendConvertData.cost = cost;
						// if (this.selected_visa_type.dependent) {
						//     this.extendConvertData.condition = this.dependentVisaDetail.visa_type_condition_id;
						// }

						if (this.visa_type_slug !== 'tourist-visa') {
							this.extendConvertData.documents = this.documents;
						} else {
							this.extendConvertData.documents = [];
						}
						this.$router.push({
							name: 'ConvertConfirm'
						})
					}
				},
				getAge() {
					var years = moment().diff(this.extendConvertVisaDetail.dob, 'years')
					return years;
				},
			},
	watch: {
		extendConvertVisaDetail: {
			immediate: true,
			handler(val) {
				if (val && val.expiry_date) {
					this.extendConvertData.start_date = val.expiry_date;
				}
			}
		}
	},
	mounted() {
		if (this.conditions.length === 1) {
			this.extendConvertData.condition = this.conditions[0].id;
		}
	},
	computed: {
		...mapGetters('VisaType', ['conditions', 'border_case_extend_condition', 'visa_type_slug']),
		...mapGetters('VisaSingle', ['convert_visa_options', 'extendConvertData', 'extraPassport', 'dependentVisaDetail', 'extendConvertVisaDetail']),
		...mapGetters({
			countries: 'CountryForTouristList/all',
		}),
		checkIfApplicantsApplicableForAgeCondition() {
			let conditions = this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0 ? this.border_case_extend_condition : this.conditions;
			let selected_condition = conditions.find((c) => {
				if (this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0) {
					return c.id === this.extendConvertData.border_condition;
				} else {
					return c.id === this.extendConvertData.condition;
				}
			});
			if (selected_condition && selected_condition.age) {
				let ageGroup = selected_condition.age.split('-');
				if (this.getAge() < parseInt(ageGroup[1])) {
					return 1;
				} else {
					return 0;
				}
			}
			return 1;
		},
		previous_visa_type_slug() {
			return this.extendConvertVisaDetail.slug;
		},
		dependent_visa_options() {
			let dependent_visa_options = this.$store.state.VisaSingle.convert_visa_options.filter(item => item.dependent);
			const office_name = this.$store.state.VisaSingle.office.toLowerCase();
			if (office_name === 'doi') {
				return dependent_visa_options;
			}
			const pokhara_office_options = ['relation-visa', 'nrn-visa', 'marriage-visa']
			return dependent_visa_options.filter((i) => pokhara_office_options.indexOf(i.slug) > -1);
		},
		showSelectVisaType() {
			return (this.extendConvertVisaDetail.slug === "official-visa" || this.extendConvertVisaDetail.slug === "diplomatic-visa")
		},
		selected_visa_type() {
			let convert_option = this.convert_visa_options.find((i) => i.id === this.extendConvertData.visa_type);
			if (convert_option) {
				if (convert_option.dependent) {
					convert_option.slug = 'dependent-visa'
				}
				return convert_option;
			}
			return false;
		},
		headerText() {
			if (!this.selected_visa_type.dependent && this.conditions.length > 1) {
				return this.selected_visa_type.type + ' Information';
			} else {
				return 'Visa Information'
			}
		},
		expiry_date() {
			return moment(this.extendConvertData.start_date).add(this.extendConvertData.days_staying, 'days').subtract(1, 'days').format('YYYY-MM-DD');
		},

		viewData: function () {
			let conditions = this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0 ? this.border_case_extend_condition : this.conditions;
			let selected_condition = conditions.find((c) => {
				if (this.fetchedConditionForBorderCase && this.border_case_extend_condition.length > 0) {
					return c.id === this.extendConvertData.border_condition;
				} else {
					return c.id === this.extendConvertData.condition;
				}
			});
			console.log(selected_condition)
			let cost = false;
			let invalid_date = false;
			let show_sre = false;
			let show_mre = false;
			let selected_day = null;
			let fill_dependent_data = false;
			if (selected_condition && selected_condition != undefined) {
				let days = selected_condition.days;
				let days_staying = this.extendConvertData.days_staying;
				if (days_staying)
					days_staying = this.borderCaseReachedDay > 0 ? parseInt(days_staying) - this.borderCaseReachedDay : parseInt(days_staying);
				for (let i = 0; i < days.length; i++) {
					if (parseInt(days[i].days) >= days_staying) {
						selected_day = days[i];
						break;
					}
				}

				if (!selected_day) {
					if (this.extendConvertData.days_staying)
						invalid_date = true;
				} else {
					cost = selected_day.cost;
					if (parseInt(selected_day.plan) === 1) {
						show_sre = true;
						show_mre = true;
					} else if (parseInt(selected_day.plan) === 2) {
						show_mre = true;
					}
				}
			} else {
				if (this.extendConvertData.days_staying)
					invalid_date = true;
			}
			// }

			return {
				invalid_date,
				show_sre,
				show_mre,
				cost,
				selected_day,
				fill_dependent_data,
			}
		},
		cost() {
			if (this.selected_visa_type.dependent || this.previous_visa_type_slug === 'consular-gratis-visa') {
				if (this.extendConvertData.apply_with_gratis !== undefined && this.extendConvertData.apply_with_gratis) {
					this.extendConvertData.visaPlan = 3;
					return "0";
				}
			}

			//if traveller dob after selected days >= maxAge of condition then fetch condition with new dob

			//subtracted selected days from traveller dob and get age
			let age = moment(this.extendConvertData.start_date).diff(moment(this.extendConvertVisaDetail.dob).subtract(parseInt(this.extendConvertData.days_staying) - 1, 'days').format('YYYY-MM-DD'), 'years');
			//condition fetched age
			if (this.conditions && this.conditions.length == 0) {
				return "0";
			}
			let selectedConditionAge = this.conditions[0].age;

			let selectedConditionAgeArray = selectedConditionAge.split('-');
			var maxAge = selectedConditionAgeArray[selectedConditionAgeArray.length - 1];


			var condition = this.conditions.find(i => i.id === this.extendConvertData.condition);

			var isGratis = true;
			if (condition !== undefined) {
				const days = condition.days;
				for (let i = 0; i < days.length; i++) {
					if (parseInt(days[i].cost) > 0) {
						isGratis = false
						break;
					}
				}
			}
			//calculation for border days;
			let dobwithmaxage = moment(this.extendConvertVisaDetail.dob).add(parseInt(maxAge), 'years')
			// removed +1 as saidy by suraj prakash aryal
			var borderFreeDays = dobwithmaxage.diff(moment(this.extendConvertData.start_date), "days");

			if (isGratis && borderFreeDays > 0 && selectedConditionAge && age >= parseInt(maxAge)) {
				if (!this.fetchedConditionForBorderCase) {
					this.borderCaseReachedDay = borderFreeDays;
					this.$store.state.VisaType.borderCaseReachedDay = borderFreeDays;
					let dob = moment(this.extendConvertVisaDetail.dob).subtract(parseInt(this.extendConvertData.days_staying) - 1, 'days').format('YYYY-MM-DD')
					this.fetchBorderCaseConditionForConvert({
						type: this.extendConvertData.visa_type,
						dob: dob
					});
					this.fetchedConditionForBorderCase = true;
				}
			} else {
				if (this.extendConvertData.days_staying === "" || parseInt(this.extendConvertData.days_staying) < this.borderCaseReachedDay) {
					this.$store.commit('VisaType/setBorderCaseExtendConditions', [])
					this.fetchedConditionForBorderCase = false;
					this.borderCaseReachedDay = 0;
				}
			}
			let cost = this.viewData.cost;

			// if (this.extendConvertData.visa_type_condition)
			if (this.viewData.selected_day) {
				let convert_option = this.convert_visa_options.find((i) => i.id === this.extendConvertData.visa_type);
				if (parseInt(this.viewData.selected_day.plan) === 1) {
					if (parseInt(this.extendConvertData.visaPlan) !== parseInt(this.viewData.selected_day.plan)) {
						if (parseInt(this.extendConvertData.visaPlan) === 2) {
							cost = parseInt(cost) + parseInt(convert_option.sre_cost);
						} else {
							cost = parseInt(cost) + parseInt(convert_option.mre_cost);
						}
					}
				} else if (this.viewData.selected_day.plan === 2) {
					if (parseInt(this.extendConvertData.visaPlan) !== parseInt(this.viewData.selected_day.plan)) {
						cost = parseInt(cost) + parseInt(convert_option.mre_cost);
					}
				}
			}
			if (cost === 0) {
				return "0";
			}
			return cost;
		},
		plan() {
			let plan = null;
			if (!this.extendConvertData.visaPlan) {
				if (this.viewData.selected_day) {
					this.extendConvertData.visaPlan = this.viewData.selected_day.plan;
					plan = this.visa_plans.find((i) => i.key === parseInt(this.viewData.selected_day.plan));
				}
			} else {
				plan = this.visa_plans.find((i) => i.key === parseInt(this.extendConvertData.visaPlan));
			}
			if (plan)
				return plan.value;


			return null;
		},
		documents() {
			if (this.selected_visa_type.dependent) {
				let dependent_visa_detail = this.dependentVisaDetail;
				if (dependent_visa_detail)
					return dependent_visa_detail.documents;
			}
			const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
			if (selected_condition) {
				return selected_condition.documents;
			} else {
				return [];
			}
		},
		message() {
			const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
			if (selected_condition) {
				return selected_condition.message;
			} else {
				return false;
			}
		},
		extension_message() {
			const selected_condition = this.conditions.find((c) => c.id === this.extendConvertData.condition);
			if (selected_condition) {
				return selected_condition.extension_message;
			} else {
				return false;
			}
		}
	}
	,
}
</script>

